import { render, staticRenderFns } from "./OkSmmWidget.vue?vue&type=template&id=00da22cf&scoped=true&"
import script from "./OkSmmWidget.vue?vue&type=script&lang=js&"
export * from "./OkSmmWidget.vue?vue&type=script&lang=js&"
import style0 from "./OkSmmWidget.vue?vue&type=style&index=0&id=00da22cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00da22cf",
  null
  
)

export default component.exports